import { VCC_STATUS } from 'app/typings/core/common/enum/vccStatus';
import { VccStatus } from 'app/typings/vcc';

const inactiveTooltip = 'Active on the day of check-in.';
const cancelledTooltip =
  'The client cancelled the booking, the refund will be issued by Staycation.';
const deactivatedTooltip =
  'VCC expire within 180 days of check-in for fraud protection.';
const toRefundTooltip = 'Refund statuses may take up to 72 hours to update.';

const VCC_TOOLTIP_MESSAGES: Record<string, string | undefined> = {
  [VccStatus.Inactive]: inactiveTooltip,
  [VccStatus.Cancelled]: cancelledTooltip,
  [VccStatus.Deactivated]: deactivatedTooltip,
  [VccStatus.ToRefund]: toRefundTooltip,

  // VCC_STATUS shares its values with VccStatus, apart from CANCELED.
  [VCC_STATUS.CANCELED]: cancelledTooltip,
};

export const getVccTooltipText = (
  status: VccStatus | VCC_STATUS
): string | undefined => {
  return VCC_TOOLTIP_MESSAGES[status];
};
